var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuote(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9626 12.65C15.2416 11.2619 15.1128 9.47926 15.1088 9.45892V7.42549V4.03645C15.1088 3.6623 14.8058 3.35864 14.431 3.35864H10.3641C9.61649 3.35864 9.00849 3.96664 9.00849 4.71426V9.45892C9.00849 9.83307 9.31147 10.1367 9.6863 10.1367H10.3641H11.7726C11.7584 10.4092 11.6892 10.7549 11.4818 11.083C11.1375 11.6259 10.4888 11.9966 9.55277 12.1837L9.00849 12.2922V14.2036H9.6863C11.5726 14.2036 13.0116 13.681 13.9626 12.65ZM6.50196 12.65C7.78166 11.2619 7.6522 9.47926 7.64813 9.45892V7.42549V4.03645C7.64813 3.6623 7.34515 3.35864 6.97032 3.35864H2.90347C2.15585 3.35864 1.54785 3.96664 1.54785 4.71426V9.45892C1.54785 9.83307 1.85083 10.1367 2.22566 10.1367H2.90347H4.31196C4.29772 10.4092 4.22859 10.7549 4.02118 11.083C3.67685 11.6259 3.02819 11.9966 2.09213 12.1837L1.54785 12.2922V14.2036H2.22566C4.112 14.2036 5.55099 13.681 6.50196 12.65Z",
    fill: "#CACACA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.614de035268d4f32f9b2be8ed141fadd.svg";
export { ForwardRef as ReactComponent };